export const useJobsConfig = () => {
  const jobsRoot = document.getElementById('portal-job-listing-root');
  const dashboardRoot = document.getElementById('dashboard-root');

  const ds = dashboardRoot?.dataset ?? {};

  // Helper to get label with fallback (handles empty strings)
  const getLabel = (value: string | undefined, fallback: string): string => {
    return value?.trim() ? value : fallback;
  };

  return {
    serviceId: jobsRoot?.dataset.serviceId ?? '',
    collectionsApi: jobsRoot?.dataset.collectionsApi ?? '',
    imagesApi: jobsRoot?.dataset.imagesApi ?? '',
    downloadsUrl: jobsRoot?.dataset.downloadsUrl ?? '',
    pageSize: Number.parseInt(jobsRoot?.dataset.pageSize ?? '10', 10),
    paginationDisplayLimit: Number.parseInt(jobsRoot?.dataset.paginationDisplayLimit ?? '10', 10),
    columnLabelsFromCms: jobsRoot?.dataset.columnLabels ? JSON.parse(jobsRoot.dataset.columnLabels) : {},
    viewFullScheduleForServiceUrl: jobsRoot?.dataset.viewFullScheduleForServiceUrl ?? '',
    labels: {
      noResultsText: jobsRoot?.dataset.labelsNoResultsText ?? 'No results found',
      previousLabel: jobsRoot?.dataset.labelsPreviousLabel ?? 'Prev',
      nextLabel: jobsRoot?.dataset.labelsNextLabel ?? 'Next',
      collectionsThisWeekLabel: jobsRoot?.dataset.collectionsThisWeekLabel ?? 'Collection this week',
      recentHistoryLabel: jobsRoot?.dataset.recentHistoryLabel ?? 'Recent history',
      // Dashboard labels
      thisWeek: getLabel(ds.labelThisWeek, 'This week'),
      jobs: getLabel(ds.labelJobs, 'Jobs'),
      scheduled: getLabel(ds.labelScheduled, 'Scheduled'),
      completed: getLabel(ds.labelCompleted, 'Completed'),
      rejected: getLabel(ds.labelRejected, 'Rejected'),
      titleUnallocated: getLabel(ds.labelTitleUnallocated, 'Your next collection is due'),
      titleCompleted: getLabel(ds.labelTitleCompleted, 'We collected your waste'),
      titleRejected: getLabel(ds.labelTitleRejected, 'We were unable to collect your waste'),
      viewSchedule: getLabel(ds.labelViewSchedule, 'View your full schedule'),
      requestCollectionQuestion: getLabel(ds.labelRequestCollectionQuestion, 'Need it collected sooner?'),
      requestCollectionCta: getLabel(ds.labelRequestCollectionCta, 'Request another collection'),
      nextScheduledCollectionSentence: getLabel(
        ds.labelNextScheduledCollectionSentence,
        '{date} is your next scheduled collection.'
      ),
      jobsCompletedMonth: getLabel(ds.labelJobsCompletedMonth, 'jobs completed this month'),
      moreJobsMonth: getLabel(ds.labelMoreJobsMonth, 'more jobs due this month'),
      statusScheduled: getLabel(ds.labelStatusScheduled, 'Scheduled'),
      statusCompleted: getLabel(ds.labelStatusCompleted, 'Completed'),
      statusRejected: getLabel(ds.labelStatusRejected, 'Rejected'),
      jobsCountLabel: getLabel(ds.labelJobsCount, '{count} jobs'),
      weeklyCollectionsSentence: getLabel(ds.labelWeeklyCollectionsSentence, 'You have {count} collections'),
      rejectedJobDetailsLink: getLabel(ds.labelRejectedJobDetailsLink, 'See what happened'),
      serviceStoppedHeading: getLabel(ds.labelServiceStoppedHeading, 'Your service has been stopped'),
      serviceStoppedSubHeading: getLabel(ds.labelServiceStoppedSubHeading, 'Invoices awaiting payment'),
      serviceStoppedText: getLabel(
        ds.labelServiceStoppedText,
        "For your next collection to be scheduled you will need to pay your overdue invoice. As soon as we receive payment your service will resume at it's usual frequency."
      ),
    },
  };
};
